export const toLocalInputValue = (iso: string) => {
  const date = new Date(iso);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const toIsoFromLocalInput = (value: string) => new Date(value).toISOString();

const toRoundedLocalInputValue = (date: Date) => {
  const rounded = new Date(date);
  rounded.setSeconds(0, 0);
  const minutes = rounded.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  rounded.setMinutes(roundedMinutes === 60 ? 0 : roundedMinutes);
  if (roundedMinutes === 60) {
    rounded.setHours(rounded.getHours() + 1);
  }

  const offset = rounded.getTimezoneOffset() * 60000;
  return new Date(rounded.getTime() - offset).toISOString().slice(0, 16);
};

export const buildDefaultAvailabilityWindow = () => {
  const start = toRoundedLocalInputValue(new Date());
  const endSeed = new Date();
  endSeed.setHours(endSeed.getHours() + 8);
  const end = toRoundedLocalInputValue(endSeed);
  return { start, end };
};

export const addDurationHours = (start: string, hours: number) => {
  const end = new Date(start);
  end.setHours(end.getHours() + hours);
  return toLocalInputValue(end.toISOString());
};

export const formatDuration = (start: string, end: string) => {
  const diffMs = new Date(end).getTime() - new Date(start).getTime();
  if (!Number.isFinite(diffMs) || diffMs <= 0) return "-";
  const totalMinutes = Math.round(diffMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};
